export default __webpack_public_path__ + "static/media/share.008aece9.svg";